import React, { useState, useEffect } from 'react';
import { getUsers, getAgreements, getTelegramAdmins, addTelegramAdmin, removeTelegramAdmin } from '../services/api';
import './Admin.css';

const Admin = () => {
  const [users, setUsers] = useState([]);
  const [agreements, setAgreements] = useState([]);
  const [telegramAdmins, setTelegramAdmins] = useState([]);
  const [newTelegramAdminId, setNewTelegramAdminId] = useState('');

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await getUsers();
        setUsers(response.data);
      } catch (error) {
        console.error('Failed to fetch users', error);
      }
    };

    const fetchAgreements = async () => {
      try {
        const response = await getAgreements();
        setAgreements(response.data);
      } catch (error) {
        console.error('Failed to fetch agreements', error);
      }
    };

    const fetchTelegramAdmins = async () => {
      try {
        const response = await getTelegramAdmins();
        setTelegramAdmins(response.data);
      } catch (error) {
        console.error('Failed to fetch telegram admins', error);
      }
    };

    fetchUsers();
    fetchAgreements();
    fetchTelegramAdmins();
  }, []);

  const handleAddTelegramAdmin = async (e) => {
    e.preventDefault();
    try {
      await addTelegramAdmin(newTelegramAdminId);
      setNewTelegramAdminId('');
      const response = await getTelegramAdmins();
      setTelegramAdmins(response.data);
    } catch (error) {
      console.error('Failed to add telegram admin', error);
    }
  };

  const handleRemoveTelegramAdmin = async (telegramId) => {
    try {
      await removeTelegramAdmin(telegramId);
      const response = await getTelegramAdmins();
      setTelegramAdmins(response.data);
    } catch (error) {
      console.error('Failed to remove telegram admin', error);
    }
  };

  return (
    <div className="admin-container">
      <h1>Admin Panel</h1>

      <div className="admin-section">
        <h2>Manage Users</h2>
        <table className="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Username</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map(user => (
              <tr key={user.id}>
                <td>{user.id}</td>
                <td>{user.username}</td>
                <td>
                  <button>Edit</button>
                  <button>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="admin-section">
        <h2>User Agreements</h2>
        <button>Export Agreements</button>
        <table className="admin-table">
          <thead>
            <tr>
              <th>User ID</th>
              <th>Accepted At</th>
            </tr>
          </thead>
          <tbody>
            {agreements.map(agreement => (
              <tr key={agreement.id}>
                <td>{agreement.user_id}</td>
                <td>{new Date(agreement.accepted_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="admin-section">
        <h2>Telegram Bot Integration</h2>
        <p>The Orchestrator AI Agent is available via Telegram.</p>
        <p>To get started, open Telegram and search for the bot username: <strong>@earngainbot</strong> (replace with your actual bot username).</p>
        <p>You can use the bot to:</p>
        <ul>
          <li>Get a summary of all users</li>
          <li>Check on a specific user's status</li>
          <li>And more!</li>
        </ul>
        <p><strong>Note:</strong> The bot will only respond to messages from the authorized admin account.</p>
      </div>

      <div className="admin-section">
        <h2>Manage Telegram Admins</h2>
        <form onSubmit={handleAddTelegramAdmin}>
          <input
            type="text"
            value={newTelegramAdminId}
            onChange={(e) => setNewTelegramAdminId(e.target.value)}
            placeholder="Enter Telegram User ID"
            required
          />
          <button type="submit">Add Admin</button>
        </form>
        <table className="admin-table">
          <thead>
            <tr>
              <th>Telegram ID</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {telegramAdmins.map(admin => (
              <tr key={admin.id}>
                <td>{admin.telegram_id}</td>
                <td>
                  <button onClick={() => handleRemoveTelegramAdmin(admin.telegram_id)}>Remove</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Admin;
